<main class="server-error-page">
  <article class="server-error-message">
    <h1>We&rsquo;ll be back soon!</h1>
    <p>
      Please hang on a moment, we are working on this and your session will resume in a few minutes.
      If it does not resume within 5 minutes, please contact SILQ on
      <a href="tel:1300556689">1300 55 66 89</a>
      .
    </p>
    <p class="signature">&mdash; SILQ Support</p>
  </article>
</main>
